import { render } from "./AppMenuNew.vue?vue&type=template&id=9c21c634&scoped=true"
import script from "./AppMenuNew.vue?vue&type=script&lang=js"
export * from "./AppMenuNew.vue?vue&type=script&lang=js"

import "./AppMenuNew.vue?vue&type=style&index=0&id=9c21c634&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c21c634"]])

export default __exports__